<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="600"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly':''">
      <a-form-item style="display:none">
        <a-input v-decorator="['installLabelId']"/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
        <a-select v-decorator="['installType',{ rules: [{ required: true, message: '请选择安装类别' }] }]">
          <a-select-option  v-for="type in restaurantTypes" :key="type.code"> {{type.label}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标签名称">
        <a-input v-decorator="['installLabelName',{ rules: [{ required: true, message: '请输入标签名称' }] }]"/>
        <!--<a-select  v-decorator="['priceName',{ rules: [{ required: true, message: '请输入字段类型' }] }]">-->
        <!--<a-select-option  v-for="(val,key) in fieldType" :key="key" :value="key">{{val}}</a-select-option>-->
        <!--</a-select>-->
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

  import { saveInstallLabel } from '@/api/master/LabelManagement'
  import pick from 'lodash.pick'
  import { getDictMap } from "../../../utils/dict"

  export default {
    name: "NoticeadModel",
    components: {
    },
    data () {
      return {
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        restaurantTypes:[],
        restaurantOperTypeMap:[],
        status:0
      }
    },
    beforeCreate () {
    },
    async created () {
        this.restaurantTypes = [];
        this.restaurantOperTypeMap = await getDictMap('install_type');
        this.restaurantOperTypeMap.forEach((value, key) => {
          // console.log(value,key)
          this.restaurantTypes.push({code: key, label: value})
        })
    },
    methods: {
      onChange(date,dateString) {
        console.log(dateString)
        this.startTime=dateString[0]
        this.endTime=dateString[1]
      },
      add() {
        this.form.resetFields()
        this.edit({installLabelId: 0})
      },
      edit(record,status) {
        this.status = status
        this.mdl = Object.assign(record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.mdl, 'installLabelId', 'installType', 'installType', 'installLabelName'))
        })
      },
      handleSubmit(e) {
        console.log(this.getSubmit)
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            this.confirmLoading = true
            if (!err) {
              console.log('Received values of form: ', values)
              this.confirmLoading = true
              saveInstallLabel(values).then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok')
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
  .readyOnly{
    pointer-events: none;
  }
</style>